import React from 'react';
import { ScrollView, View, Text, SafeAreaView } from 'react-native';

import { styles } from './styles';
import { FormattedMessage } from 'react-intl';

const Terms = () => (
  <ScrollView>
    <View style={styles.container}>
      <Text style={styles.title}>
        <FormattedMessage id='terms.policaDePrivacidade'/>
       </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.aSuaPrivacidade'/>
       
      </Text>
      <Text style={styles.title}>
      <FormattedMessage id='terms.politicaDeCookies'/>
        </Text>
      <Text style={styles.subtitle}>
      <FormattedMessage id='terms.oQueSaoCookies'/>
        </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.comoEAPratica'/>
      </Text>
      <Text style={styles.subtitle}>
      <FormattedMessage id='terms.comoUsamosCookies'/>
        </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.UtilizamosCookies'/>
      </Text>
      <Text style={styles.subtitle}>
      <FormattedMessage id='terms.desativarCookies'/>
      </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.vocePode'/>
      </Text>
      <Text style={styles.subtitle}>
      <FormattedMessage id='terms.cookiesQueDefinimos'/>
     s</Text>
      <Text style={styles.listItem}>
      <FormattedMessage id='terms.cookiesRelacionadosConta'/>
      </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.seVoceCriar'/>
      </Text>
      <Text style={styles.listItem}>
      <FormattedMessage id='terms.cookiesRelacionadosLogin'/>
     </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.utilizamosCookiesQuando'/>
      </Text>
      <Text style={styles.listItem}>
      <FormattedMessage id='terms.cookiesRelacionadosBoletinsEmail'/>
      </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.esteAplicativoOfereceServicos'/>
      </Text>
      <Text style={styles.listItem}>
      <FormattedMessage id='terms.pedidosProcessando'/>
      </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.esteAplicativoOfereceFacilidades'/>
      </Text>
      <Text style={styles.title}>
      <FormattedMessage id='terms.compromissoDoUsuario'/>
      </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.oUsuarioSeCompromete'/>
      </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.A)'/>
      </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.B)'/>
      </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.C)'/>
      </Text>
      <Text style={styles.subtitle}>
      <FormattedMessage id='terms.maisInformacoes'/>
      </Text>
      <Text style={styles.text}>
      <FormattedMessage id='terms.esperamosQueEstejaEsclarecido'/>
      </Text>
      {/* <View style={{ paddingBottom: 100 }}></View> */}
    </View>
  </ScrollView>

)

export default Terms